export default class RateCheckerData {
    constructor(data) {
        Object.defineProperty(this, "comparativeRateSummaries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!data || typeof data === 'boolean') {
            this.comparativeRateSummaries = [];
        }
        else {
            this.comparativeRateSummaries = data.map((roomInfo) => ({
                accommodationName: roomInfo.name,
                directRate: roomInfo.direct,
                rates: roomInfo.rates.map((rate) => {
                    return {
                        price: rate.channel_price,
                        sourceName: rate.channel_name,
                    };
                }),
            }));
        }
    }
}
